import { Box, Button, Stack, Alert, CircularProgress, Divider, Dialog, DialogTitle, DialogContent, DialogContentText, DialogActions } from "@mui/material";

import { MeetingStepper, Schedule, Agenda, Attendees, Projects } from "./index";
import { useCreateMeeting } from "../../hooks/useCreateMeeting";

export const CreateMeeting = ({ refetch, initialData, mode = 'create', onClose }: { refetch: () => void, initialData?: any, mode?: 'create' | 'edit', onClose: () => void }) => {

    const {
        errors, loading, submitError, activeStep, formData, showApplyAllDialog,
        handleNext, handleChange, addExternalAttendee, deleteExternalAttendee,
        onChangeExternalAttendee, onSubmit, handleApplyAllResponse, handleBack
    } = useCreateMeeting({
        refetch: () => {
            refetch();
            onClose();
        }, initialData, mode
    });

    const hasErrors = Object.keys(errors).length > 0;

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3, height: '100%' }}>
            <Box flex={1}>
                <Box px={3} py={3}>
                    <MeetingStepper activeStep={activeStep} />
                </Box>
                <Divider />
                <Box px={4} py={2}>
                    {
                        activeStep === 0 && (
                            <Schedule meetingData={formData} onChange={handleChange} errors={errors} isRecurring={initialData?.is_recurring} />
                        )
                    }
                    {
                        activeStep === 1 && (
                            <Agenda meetingData={formData} onChange={handleChange} errors={errors} />
                        )
                    }
                    {
                        activeStep === 2 && (
                            <Attendees meetingData={formData} onChange={handleChange} onChangeExternalAttendee={onChangeExternalAttendee} addExternalAttendee={addExternalAttendee} deleteExternalAttendee={deleteExternalAttendee} errors={errors} />
                        )
                    }
                    {
                        activeStep === 3 && (
                            <Projects meetingData={formData} onChange={handleChange} errors={errors} />
                        )
                    }
                </Box>
                {hasErrors && (
                    <Box px={2}>
                        <Alert severity="error">
                            Please fix the errors above before proceeding
                        </Alert>
                    </Box>
                )}
                {submitError && (
                    <Box px={2}>
                        <Alert severity="error">
                            {submitError}
                        </Alert>
                    </Box>
                )}
            </Box>
            <Stack direction="row" spacing={2} justifyContent="flex-end" flexShrink={0} bgcolor={'action.hover'} p={2}>
                <Button onClick={handleBack} variant="outlined" disabled={activeStep === 0 || loading}>Back</Button>
                {
                    activeStep === 3 ? (
                        <Button onClick={onSubmit} variant="contained" disabled={hasErrors || loading}>
                            {loading && <CircularProgress size={20} sx={{ mr: 1 }} />}
                            {mode === 'edit' ? 'Update Meeting' : 'Create Meeting'}
                        </Button>
                    ) :
                        <Button onClick={handleNext} variant="contained" disabled={hasErrors}>Next</Button>
                }
            </Stack>

            <Dialog open={showApplyAllDialog} onClose={() => handleApplyAllResponse && handleApplyAllResponse(false)}>
                <DialogTitle>Apply Changes to Recurring Meetings?</DialogTitle>
                <DialogContent>
                    <DialogContentText>Would you like to apply the attendee changes to all recurring meetings in this series, or only to this specific meeting ?</DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => handleApplyAllResponse && handleApplyAllResponse(false)} variant="outlined">Only This Meeting</Button>
                    <Button onClick={() => handleApplyAllResponse && handleApplyAllResponse(true)} variant="contained" autoFocus>Apply to All</Button>
                </DialogActions>
            </Dialog>

        </Box>
    );


}